// https://dev.to/workshub/state-management-battle-in-react-2021-hooks-redux-and-recoil-2am0
// https://mparavano.medium.com/stop-using-giant-switch-statements-in-your-react-reducers-abfb8aa8ede7

import { AuthActionMap } from "../domain/Auth/services/AuthActionMap";


const actionMap = new Map<string, any>([
  // ...AuthActionMap
]);

export const reducer = (state, action) => {

  const mappedAction = actionMap.get(action.type);
  return mappedAction ? mappedAction(state, action) : state;

  // switch (action.type) {
  //   case "GET_ALL_EMPLOYEE": {
  //     return {
  //       ...state,
  //       employeeListLoading: false,
  //       employees: action.payload,
  //     };
  //   }
  //   case "ADD_NEW_EMPLOYEE": {
  //     return {
  //       ...state,
  //       employees: [...state.employees, action.payload],
  //     };
  //   }
  //   case "DELETE_EMPLOYEE": {
  //     return {
  //       ...state,
  //       employees: state.employees.filter((e) => e.ID === action.payload.ID),
  //     };
  //   }

  //   case "SET_EMPLOYEE_INACTIVE":
  //     return {
  //       ...state,
  //       posts: state.posts.concat(action.payload),
  //     };
  //   case "SET_EMPLOYEE_LIST_LOADING":
  //     return {
  //       ...state,
  //       employeeListLoading: true,
  //     };

  //   case "SET_EMPLOYEE_LIST_NOT_LOADING":
  //     return {
  //       ...state,
  //       employeeListLoading: false,
  //     };

  //   case "ADD_NEW_ASSET": {
  //     return {
  //       ...state,
  //       assets: [...state.assets, action.payload],
  //     };
  //   }

  //   case "SET_ASSET_LIST_LOADING":
  //     return {
  //       ...state,
  //       employeeListLoading: true,
  //     };

  //   case "SET_ASSET_LIST_NOT_LOADING":
  //     return {
  //       ...state,
  //       employeeListLoading: false,
  //     };

  //   case "SET_ERROR":
  //     return {
  //       ...state,
  //       error: action.payload,
  //     };
  //   default:
  //     return state;
  // }
};

